export default __webpack_public_path__ + "static/scale-344ade9981b93718e3c35ead610e0f58.png";